
export default function Contact() {
  return (
    <section id="contact" className="bg-gray-900 rounded-t-[40px] py-20">
      <div className="max-w-6xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-6">
            Get In Touch
          </h2>
          <p className="text-lg text-gray-400">
            We're here to help with any questions about our applications
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
          <div>
            <h3 className="text-sm uppercase tracking-wider text-gray-400 mb-6 font-medium">
              Address
            </h3>
            <div className="space-y-4 text-white">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-purple-400 mt-1"></i>
                <div>
                  <p className="text-base">HAJDUK VELJKOVA 7-9</p>
                  <p className="text-base">Svilajnac, 586521</p>
                  <p className="text-base">Serbia</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-sm uppercase tracking-wider text-gray-400 mb-6 font-medium">
              Email
            </h3>
            <div className="flex items-start gap-3">
              <i className="ri-mail-line text-xl text-purple-400 mt-1"></i>
              <a 
                href="mailto:help@madrasdoosvilajnac.com"
                className="text-base text-white hover:text-purple-400 transition-colors"
              >
                help@madrasdoosvilajnac.com
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm uppercase tracking-wider text-gray-400 mb-6 font-medium">
              Phone
            </h3>
            <div className="flex items-start gap-3">
              <i className="ri-phone-line text-xl text-purple-400 mt-1"></i>
              <a 
                href="tel:+15822600539"
                className="text-base text-white hover:text-purple-400 transition-colors"
              >
                +1 5822600539
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 MADRAS DOO SVILAJNAC. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 text-sm hover:text-white transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
